import { scalarLayerSlot } from '../../shared/array-types';

/** Viewer-local gates for a readable shared creature blob. Control is the
 * target-row verdict; peek opens bags, never the creature's stat block. */
export function creatureDisplayAccess(caster: unknown, viewerId = '', controlVerdict?: boolean): { control: boolean; loot: boolean; peek: boolean; inventory: boolean; dead: boolean } {
    const control = controlVerdict ?? (ftHasPlayerPermission(caster) || ftHasCampaignPermission(caster));
    const statuses = ftCreatureStatuses(caster, 'target');
    const ec = (caster as { encounter_creatures?: unknown } | null)?.encounter_creatures;
    const hasStatus = (id: string): boolean => statuses.some((row: unknown) => String(ftItemsCol(row, 'item_id') ?? '').toUpperCase() === id);
    const dead = Number(ftEncounterCreatureField(ec, 'encounter_creature_dead') ?? 0) === 1;
    const vitality = ftComputedValue(caster, 'vitality', 'v_current');
    const loot = dead || (vitality != null && Number(vitality) <= 0)
        || String(scalarLayerSlot(ftComputedValue(caster, 'vitality', 'v_status')) ?? '') === '9FEE2E8A-9CF7-D74D-5D16-B86C2603A1FA'
        || hasStatus('F73BA661-ADD2-26E0-E265-FBEB7E5E6AF1') || hasStatus('095BC6BC-06F6-74E0-2B8A-FC1F32AF809B');
    const targetId = String(ftEncounterCreatureField(ec, 'encounter_creature_id') ?? '').toUpperCase();
    const viewer = viewerId.toUpperCase();
    const peek = !loot && viewer !== '' && viewer !== targetId && statuses.some((row: unknown) =>
        String(ftItemsCol(row, 'item_id') ?? '').toUpperCase() === '35B277D9-F5E7-14A7-D2B1-9326C410549A'
        && String(ftLayerValue(row, 'status_caster_id') ?? '').toUpperCase() === viewer);
    return { control, loot, peek, inventory: control || loot || peek, dead };
}
